export const checkCircularReference = () => () => {
    return async function () {
        await this.execute(
            () => this.runAction(
                () => this.actions.checkCircularReference(),
                {action: '检测循环引用'}
            )
        )
    }
}
